"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sandbox = _interopRequireDefault(require("./sandbox"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Notebook = exports.default = /*#__PURE__*/function (_React$PureComponent) {
  function Notebook() {
    var _this;
    (0, _classCallCheck2.default)(this, Notebook);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Notebook, [].concat(args));
    (0, _defineProperty2.default)(_this, "updateHeight", function (editorElement, code) {
      // eslint-disable-next-line no-param-reassign
      editorElement.style.height = "".concat((code.split('\n').length + 1) * 18, "px");
      // eslint-disable-next-line no-param-reassign
      editorElement.parentNode.style.height = "".concat(code.split('\n').length * 18, "px");
    });
    return _this;
  }
  (0, _inherits2.default)(Notebook, _React$PureComponent);
  return (0, _createClass2.default)(Notebook, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var isFocused = this.props.isFocused;
      var code = this.props.notebookState.content;
      var editorElement = document.createElement('div');
      this.notebook.appendChild(editorElement);
      this.updateHeight(editorElement, code);
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var monaco, isEmpty, handleAddExtraLib;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return new Promise(function (resolve) {
                require.ensure([], function (require) {
                  resolve(require('monaco-editor'));
                });
              });
            case 1:
              monaco = _context.sent;
              document.querySelector('body').classList.add('monaco-editor');
              _this2.editor = monaco.editor.create(editorElement, {
                overflowWidgetsDomNode: document.body,
                fixedOverflowWidgets: true,
                automaticLayout: true,
                hideCursorInOverviewRuler: true,
                minimap: {
                  enabled: false,
                  showSlider: false
                },
                contextmenu: false,
                scrollbar: {
                  vertical: 'hidden',
                  handleMouseWheel: false
                },
                value: code,
                language: 'javascript',
                lineNumbers: 'off'
              });
              isEmpty = _this2.editor.createContextKey('isEmpty', !code);
              _this2.editor.onDidChangeModelContent(function () {
                var newCode = _this2.editor.getValue();
                _this2.updateHeight(editorElement, newCode);
                _this2.editor.layout();
                isEmpty.set(!newCode);
                _this2.props.onChange(_objectSpread(_objectSpread({}, _this2.props.notebookState), {}, {
                  content: newCode
                }));
              });
              if (_this2.editor.onDidFocusEditor) {
                _this2.editor.onDidFocusEditorWidget(function () {
                  _this2.props.onFocus();
                });
              }
              _this2.editor.onMouseDown(function () {
                _this2.props.onFocus();
              });
              _this2.editor.onDidBlurEditorWidget(function () {
                _this2.props.onBlur();
              });
              _this2.editor.addCommand(monaco.KeyCode.Backspace, function () {
                _this2.props.onRemove();
              }, 'isEmpty');
              if (isFocused) {
                process.nextTick(function () {
                  return _this2.editor.focus();
                });
              }
              handleAddExtraLib = function handleAddExtraLib(_ref2) {
                var _monaco$languages;
                var libName = _ref2.libName,
                  libCode = _ref2.libCode;
                if (!((_monaco$languages = monaco.languages) !== null && _monaco$languages !== void 0 && _monaco$languages.typescript.javascriptDefaults.getExtraLibs()[libName])) {
                  var _monaco$languages2;
                  (_monaco$languages2 = monaco.languages) === null || _monaco$languages2 === void 0 || _monaco$languages2.typescript.javascriptDefaults.addExtraLib(libCode, libName);
                }
              };
              return _context.abrupt("return", _this2.props.sandbox.register(_this2.props.ramlClientConfig, _this2.props.workerPath, handleAddExtraLib));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.sandbox.unregister();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        _this$props$notebookS = _this$props.notebookState,
        exec = _this$props$notebookS.exec,
        isLoading = _this$props$notebookS.isLoading,
        isExecuted = _this$props$notebookS.isExecuted,
        onExecute = _this$props.onExecute;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "notebook"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(c) {
          _this3.notebook = c;
        },
        className: "editor"
      }), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "play".concat(isLoading ? ' loading' : ''),
        onClick: isLoading ? null : onExecute
      }, isLoading ? null : /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 20 20"
      }, /*#__PURE__*/_react.default.createElement("polygon", {
        points: "8,6 14,10 8,14"
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "10",
        cy: "10",
        r: "9",
        strokeWidth: "2",
        fill: "transparent"
      })), isLoading ? 'Executing ...' : 'Play snippet')), (exec === null || exec === void 0 ? void 0 : exec.result) !== undefined ? /*#__PURE__*/_react.default.createElement("div", {
        className: "success"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "block-number"
      }, "$".concat(exec.blockNumber, "=")), /*#__PURE__*/_react.default.createElement("div", {
        className: "result"
      }, stringify(exec.result))) : null, (exec === null || exec === void 0 ? void 0 : exec.error) !== undefined ? /*#__PURE__*/_react.default.createElement("div", {
        className: "error"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "block-number"
      }, "$".concat(exec.blockNumber, "=")), /*#__PURE__*/_react.default.createElement("div", {
        className: "result"
      }, exec.error.stack !== undefined ? exec.error.stack : exec.error)) : null, exec && isExecuted && exec.error === undefined && exec.result === undefined ? /*#__PURE__*/_react.default.createElement("div", {
        className: "success"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "block-number"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "result"
      }, "Code snippet executed with no results")) : null);
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(Notebook, "propTypes", {
  notebookState: _propTypes.default.object,
  isFocused: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  workerPath: _propTypes.default.string,
  onExecute: _propTypes.default.func,
  sandbox: _propTypes.default.object,
  ramlClientConfig: _propTypes.default.object
});
(0, _defineProperty2.default)(Notebook, "defaultProps", {
  notebookState: {
    content: ''
  },
  workerPath: 'assets/worker.js',
  isFocused: false,
  onChange: function onChange() {},
  onRemove: function onRemove() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onExecute: function onExecute() {},
  sandbox: new _sandbox.default()
});
function stringify(object) {
  if (object === 'Client has been successfully created') {
    return object;
  }
  if (object !== null && object !== void 0 && object.toDescription) {
    return object.toDescription();
  }
  try {
    return JSON.stringify(object, null, 2);
  } catch (err) {
    return object.toString();
  }
}
//# sourceMappingURL=component.js.map